import { render, staticRenderFns } from "./parentMessage.vue?vue&type=template&id=1437dbe7&scoped=true"
import script from "./parentMessage.vue?vue&type=script&lang=js"
export * from "./parentMessage.vue?vue&type=script&lang=js"
import style0 from "./parentMessage.vue?vue&type=style&index=0&id=1437dbe7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1437dbe7",
  null
  
)

export default component.exports